import { c as _c } from "react/compiler-runtime";
import { IcoClose24 } from '@onefootprint/icons';
import * as RadixDialog from '@radix-ui/react-dialog';
import { cx } from 'class-variance-authority';
import IconButton from '../../icon-button';
import Text from '../../text';
export const HEADER_HEIGHT = 52;
type HeaderProps = {
  title?: string;
  closeAriaLabel?: string;
  onClose?: () => void;
};
const Header = t0 => {
  const $ = _c(12);
  const {
    title,
    closeAriaLabel: t1,
    onClose
  } = t0;
  const closeAriaLabel = t1 === undefined ? "Close" : t1;
  const t2 = !!title;
  let t3;
  if ($[0] !== t2) {
    t3 = cx("h-[52px] w-full flex items-center justify-between p-2", {
      "border-b border-solid border-b-tertiary": t2
    });
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== closeAriaLabel || $[3] !== onClose) {
    t4 = <RadixDialog.Close asChild={true}><div><IconButton aria-label={closeAriaLabel} onClick={onClose} icon={IcoClose24} /></div></RadixDialog.Close>;
    $[2] = closeAriaLabel;
    $[3] = onClose;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== title) {
    t5 = title && <RadixDialog.Title className="flex grow items-center justify-center h-full"><Text variant="label-2">{title}</Text></RadixDialog.Title>;
    $[5] = title;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="h-8 w-8" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t7 = <div className={t3}>{t4}{t5}{t6}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default Header;